module.exports = __webpack_public_path__ + "media/img/illustrations/eye-shape-784e2e338d6cfa6ebacaeaea59d0a9e8.svg";